export interface ICompany {
  email?: string;
  auxiliaire?: string;
  siret?: string;
  raisonSociale?: string;
  tiers?: string;
}

export class Company implements ICompany {
  constructor(
    public email?: string,
    public auxiliaire?: string,
    public siret?: string,
    public raisonSociale?: string,
    public tiers?: string
  ) {
  }
}
